import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import './ChatWindow.css'; // Importing CSS for ChatWindow

// ChatWindow component handles user input and displays messages
const ChatWindow = () => {
  // State to hold messages
  const [messages, setMessages] = useState([]);
  // State to hold current user input
  const [input, setInput] = useState('');
  // State to handle loading state
  const [loading, setLoading] = useState(false);
  // Reference to messages container for scrolling
  const messagesContainerRef = useRef(null);

  // Scroll to bottom of messages container
  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  }, [messages, loading]);

  // Handler for sending a message
  const sendMessage = async () => {
    if (input.trim() === '') return; // Prevent sending empty messages

    // Add user message to the chat
    const userMessage = { sender: 'user', text: input };
    setMessages([...messages, userMessage]);
    setInput(''); // Clear input field
    setLoading(true); // Set loading state

    try {
      // Send the user message to the backend using the environment variable
      const response = await axios.post(process.env.REACT_APP_API_URL, { message: input });

      // Add bot response to the chat
      const botMessage = { sender: 'bot', text: response.data.reply };
      setMessages((prevMessages) => [...prevMessages, botMessage]);
    } catch (error) {
      console.error('Error sending message:', error);
      const errorMessage = { sender: 'bot', text: 'This feature is coming soon!' };
      setMessages((prevMessages) => [...prevMessages, errorMessage]);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  // Handler for pressing Enter key
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };

  return (
    <div className="chat-window">
      <div className="messages" ref={messagesContainerRef}>
        {messages.map((msg, index) => (
          <div key={index} className={msg.sender}>
            <div className={`message ${msg.sender}`}>
              <span>{msg.text}</span>
            </div>
          </div>
        ))}
        {loading && (
          <div className="bot">
            <div className="message bot">
              <span>Typing...</span>
            </div>
          </div>
        )}
      </div>
      <div className="input-area">
        <input
          type="text"
          placeholder="Type your message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <button onClick={sendMessage} disabled={loading}>
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatWindow;
